import { Inject, Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})

export class ResourcePageService {
  private readonly resourcePageBaseApiUrl: string;

 
  constructor(@Inject('BASE_URL') baseUrl: string, private dataService: DataService) {
    this.resourcePageBaseApiUrl = `${baseUrl}api/resource-page`;
  }

  public getResourceHeader(industry: string) {
    let resourcePageHeaderApiUrl = `${this.resourcePageBaseApiUrl}/header/${industry}`;

    return this.dataService.get<any>(resourcePageHeaderApiUrl);
  }

  public getResourcePageNavigation() {
    let resourcePageNavigationApiUrl = `${this.resourcePageBaseApiUrl}/navigation`;

    return this.dataService.get<any>(resourcePageNavigationApiUrl);
  }
}
